/** @jsxImportSource @emotion/react */
import {useDispatch, useSelector} from 'react-redux';
import {IAppState} from '../../../../core/redux/IAppState';
import * as R from 'ramda';
import {getActivePassesWithSeason, getMostActivePass} from '../../module';
import ImmutableMap from '../../../../language/ImmutableMap';
import {getError, getLoading} from '../../../../core/redux/api/module';
import {ACTION_TYPE} from '../../../../core/redux/actionType';
import {
  getErroredRedemptionHistory,
  getErroredResortHistory,
  getLoadingRedemptionHistory,
  getLoadingResortHistory,
} from './module';
import ModalTabHeader, {Tab} from '../../../../layout/modal/ModalTabHeader';
import calendar from '../../../../assets/icons/calendar.svg';
import history from '../../../../assets/icons/history.svg';
import {useEffect, useMemo, useState} from 'react';
import {getResortDetailsAction} from '../../../../resortDetails/getResortDetailsAction';
import {clearResortRedemptionsAction} from './clearResortHistoryAction';
import {getRedemptionHistoryAction} from './getRedemptionHistoryAction';
import {getRedemptionTypesAction} from './getRedemptionTypesAction';
import {getDtwEntitlementsAction} from '../directToWindow/getDtwEntitlementsAction';
import {doNothing} from '../../../../language/module';
import {css} from '@emotion/react';
import ModalView, {ModalContent} from '../../../../layout/modal/ModalView';
import Switcher from '../../../../layout/Switcher';
import {Loader} from '../../../../forms/elements/loader/Loader';
import {ViewDaysTab} from './ViewDaysTab';
import ViewHistoricalTab from './ViewHistoricalTab';
import {getResortRedemptionsAction} from './getResortRedemptionsAction';
import {Redemption} from '../redemption';
import {redeemEntitlementAction} from '../redeemEntitlementAction';
import { getResource } from '../../../../language/resources/getResource';
import { bulkCorrectionAction } from '../bulkCorrectionAction';
import { MigrationRequest } from '../migrationRequest';
import { migrateRedemptionsAction } from '../migrateRedmeptionsAction';
import { showSnackbarAction } from '../../../../snackbar/snackbarAction';
import { clearApiErrorAction } from '../../../../core/redux/api/clearApiErrorAction';
import { ApiError } from '../../../../core/redux/api/apiError';

const enum TABS {
  VIEW_DAYS,
  VIEW_HISTORICAL_DAYS,
};

type Props = {
  guestId: string;
  onDismiss?: () => void;
}


export const ViewDaysModal = (props: Props) => {

  const guest = useSelector((state: IAppState) => state.guests.get(props.guestId));
  const resources = useSelector((state: IAppState) => state.locale);
  const dateFormat = useSelector((state: IAppState) => state.defaultDateFormat);
  const passEntitlementId = useSelector((state: IAppState) => state.resortToolsConfig.dtwCategoryId);
  const allEntitlementTypes = useSelector((state: IAppState) => state.entitlementTypesDetails?.allEntitlementTypes);
  const allResorts = useSelector((state: IAppState) => state.resortDetails?.allResorts);
  const redemptionTypes = useSelector((state: IAppState) => state.redemptionTypes);
  const allowCorrectiveRedemption = useSelector((state: IAppState) => R.includes(state.userState.role, state.resortToolsConfig.enableCorrectiveRedemption));
  const allowGlobalRedemption = useSelector((state: IAppState) => R.includes(state.userState.role, state.resortToolsConfig.enableGlobalRedemption));
  const allowPassCorrection = useSelector((state: IAppState) => R.includes(state.userState.role, state.resortToolsConfig.enablePassUsageCorrection));
  const homeResort = useSelector((state: IAppState) => state.selectedResort);
  const migrationError = useSelector((state: IAppState) => getError(state, props.guestId, ACTION_TYPE.MIGRATE_REDEMPTIONS_REQUEST));

  // View Days
  const resortHistories = useSelector((state: IAppState) => state.guestResortHistories);
  const isRedeeming = useSelector((state: IAppState) => !!getLoading(state, props.guestId, ACTION_TYPE.REDEEM_ENTITLEMENT_REQUEST));
  const isLoadingResorts = useSelector((state: IAppState) => state.resortDetails?.isLoadingResorts);

  const isLoadingResortHistory = useSelector((state: IAppState) => {
    return (resortAbbrev: string) =>
      getLoadingResortHistory(state, props.guestId, resortAbbrev);
  });
  const errorResortHistory = useSelector((state: IAppState) => getErroredResortHistory(state, props.guestId));

  // View Historical
  const entitlementRedemptions = useSelector((state: IAppState) => state.guestRedemptionHistories.get(props.guestId));
  const isLoadingHistory = useSelector((state: IAppState) => !!getLoadingRedemptionHistory(state, props.guestId));
  const errorRedemptionHistory = useSelector((state: IAppState) => getErroredRedemptionHistory(state, props.guestId));
  const isLoadingDtw = useSelector((state: IAppState) => !!getLoading(state, props.guestId, ACTION_TYPE.GET_DTW_ENTITLEMENTS_REQUEST));
  const users = useSelector((state: IAppState) => state.users);
  const userId = useSelector((state: IAppState) => state.userState.userId);

  const dispatch = useDispatch();

  const passes = useMemo(() => {
    return (
      getActivePassesWithSeason(
        passEntitlementId,
        guest,
        allEntitlementTypes || ImmutableMap.empty()
      ) || []
    );
  }, [passEntitlementId, guest, allEntitlementTypes]);
  
  useEffect(() => {
    const showSnackbar = (message: string) => dispatch(showSnackbarAction(message, true));
    const clearError = (error: ApiError) => dispatch(clearApiErrorAction(error.requestId, error.actionType));
      if (migrationError) {
          showSnackbar(migrationError.errorMsg);
          dispatch(clearError(migrationError));
      }
  }, [migrationError, dispatch]);
      
  const [selectedTab, setSelectedTab] = useState<TABS>(TABS.VIEW_DAYS);
  const [refreshKey, setRefreshKey] = useState<number>(Date.now());
  const [refreshKey2, setRefreshKey2] = useState<number>(Date.now() * -1)

  

  useEffect(()=>{
    console.log('DTW loading:', isLoadingDtw);
    if (!isLoadingResorts && !allResorts) {
      dispatch(getResortDetailsAction())
    }
    dispatch(clearResortRedemptionsAction())
    dispatch(getRedemptionTypesAction())
    dispatch(getDtwEntitlementsAction(props.guestId))
  },[isLoadingResorts, allResorts, dispatch, props.guestId])

  const getResortHistory = (guestId: string, entitlementId: number, resortAbbrev: string, resortName: string) => dispatch(
    getResortRedemptionsAction(guestId, entitlementId, resortAbbrev, resortName)
  );
  const redeemEntitlement = (redemption: Redemption) => dispatch(redeemEntitlementAction(redemption))
  const getRedemptionHistory = (guestId: string) => dispatch(getRedemptionHistoryAction(guestId))
  const bulkCorrection = (redemptions: Redemption[]) => dispatch(bulkCorrectionAction(redemptions))
  const migrateRedemptions = (request: MigrationRequest) => dispatch(migrateRedemptionsAction(request))
  const refreshDialog = () => {
    setRefreshKey(Date.now());
    setRefreshKey2(Date.now() * -1);
  }
  const onDismiss = () => (props.onDismiss || doNothing)();
  const onTabChange = (newTab: TABS) => setSelectedTab(newTab);

  const TABS_DATA: Tab[] = [
    { icon: calendar, heading: getResource(resources, 'VIEW_DAYS_VIEW_DAYS_TAB_HEADER') },
    { icon: history, heading: getResource(resources, 'VIEW_DAYS_VIEW_HISTORICAL_TAB_HEADER')}
  ];
  

  return (
    <ModalView onDismiss={onDismiss}>
      <ModalTabHeader resources={resources} tabs={TABS_DATA} onTabChange={onTabChange} onDismiss={onDismiss} rootCss={css`margin-bottom: 25px;`} />

      <ModalContent>
        <Switcher selectedIndex={selectedTab}>
          {
            isLoadingDtw || isRedeeming
              ? <Loader />
              :           <ViewDaysTab key={refreshKey}
                                       guest={guest!}
                                       passEntitlementId={passEntitlementId}
                                       allEntitlementTypes={allEntitlementTypes!}
                                       homeResort={homeResort}
                                       allResorts={(allResorts || ImmutableMap.empty()).filter(key => key !== 'ALL')}
                                       passes={passes}
                                       preferredPass={getMostActivePass(guest, passes || [])}
                                       resortHistories={resortHistories}
                                       isRedeeming={isRedeeming}
                                       isLoadingResorts={isLoadingResorts}
                                       isLoadingResortHistory={isLoadingResortHistory}
                                       errorResortHistory={errorResortHistory}
                                       getResortHistory={getResortHistory}
                                       redemptionTypes={redemptionTypes}
                                       redemptions={entitlementRedemptions}
                                       redeemEntitlement={redeemEntitlement}
                                       allowCorrectiveRedemption={allowCorrectiveRedemption}
                                       allowGlobalRedemption={allowGlobalRedemption}
              />
          }

          <ViewHistoricalTab key={refreshKey2}
                             resources={resources}
                             dateFormat={dateFormat}
                             guest={guest!}
                             passEntitlementId={passEntitlementId!}
                             allEntitlementTypes={allEntitlementTypes|| ImmutableMap.empty()}
                             allResorts={allResorts || ImmutableMap.empty()}
                             redemptions={entitlementRedemptions}
                             shouldShowChart={selectedTab === TABS.VIEW_HISTORICAL_DAYS}
                             isLoadingHistory={isLoadingHistory}
                             isRedeeming={isRedeeming}
                             errorRedemptionHistory={errorRedemptionHistory}
                             getRedemptionHistory={getRedemptionHistory}
                             totalResortCount={allResorts!.count()}
                             redemptionTypes={redemptionTypes}
                             homeResort={homeResort}
                             bulkCorrection={bulkCorrection}
                             migrateRedemptions={migrateRedemptions}
                             allowPassCorrection={allowPassCorrection}
                             refreshDialog={refreshDialog}
                             users={users}
                             currentUserId={userId}
          />
        </Switcher>
      </ModalContent>
    </ModalView>
  );

}
